import { TextInput } from 'pages/content/components/jobs/components/atoms'
import { Box, ListItem, Typography } from '@material-ui/core'
import styled, { css } from 'styled-components'
import { Button } from 'common/atoms/Button/Button'
import { ReactComponent as CloseIcon } from 'icons/closed-icon.svg'

export const JobSearchInputContainer = styled(Box)`
  && {
    border: 1px solid ${({ theme }) => theme.colors.accent};
    display: flex;
    align-items: center;
    border-radius: 5rem;
    overflow: hidden;
    padding: 0 0.4rem;
    padding-right: 0.875rem;
    height: 100%;
  }
  .MuiInputBase-root {
    border: 0px;
  }
`

export const JobSearchInput = styled(TextInput)`
  .MuiInputBase-root {
    border: 0px;
  }
  width: 100%;
`

export const FilterButtonContainer = styled(Button)`
  && {
    color: ${({ theme }) => theme.colors.accent};
    border-radius: 100px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
`

export const MiniJobCardContainer = styled(Box)`
  && {
    border-radius: 1rem;
    cursor: pointer;
    scroll-margin-top: 1.75rem;
  }
`

export const MiniJobCardHeader = styled(Box)`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
`

export const MiniJobCardMain = styled(Box)`
  margin: 1.2rem 0 auto;
`

export const MiniJobCardFooter = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    flex-direction: column;
    gap: 0.5rem;
  }
`

export const MiniJobCardAvatarImage = styled.img`
  width: 40px;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.primary};
  border-radius: 50%;
`

export const MiniJobCardText = styled(Typography)<{ fontSize?: number; hitText?: boolean }>`
  && {
    width: 100%;
    color: ${({ theme, hitText }) => (hitText ? theme.colors.accent : theme.colors.accent1)};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: capitalize;
    cursor: pointer;
  }
`

export const DescriptionText = styled(Typography)`
  && {
    width: 100%;
    display: -webkit-box;
    overflow-wrap: break-word;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    color: ${({ theme }) => theme.colors.accent1};
    font-size: 0.875rem;
  }
`

export const EllipsisButton = styled(Box)`
  display: flex;
  justify-content: end;
`

export const StyledJobSearchContainer = styled(Box)`
  & {
    scroll-margin-top: calc(1.5625rem + 70px);
  }
`

export const StyledFiltersContainer = styled.div<{isCanadaOrUS?: boolean}>`
  height: 2rem;
  &.desktop {
    width: 100%;
    display: grid;
    gap: 1.125rem;
    grid-template-columns: ${ props => props.isCanadaOrUS ? css`repeat(6, 1fr)` : css`repeat(3, 1fr)`};
    grid-auto-flow: column;
    justify-content: start;
    align-content: center;
  }

  &.mobile {
    display: flex;
    gap: 1rem;
    overflow-x: scroll;
    overflow-y: hidden;
    position: relative;
    gap: 0.25rem;

    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .obsidi-select-molecule {
      flex-shrink: 0;
      flex-basis: 60%;
    }
  }
`

export const StyledCaretContainer = styled(Box)`
  & {
    pointer-events: none;
    transition: opacity 0.34s;
    opacity: 1;
  }

  &.hide-caret {
    opacity: 0;
  }
`

export const StyledJobsFilterDrawerContainer = styled(Box)`
  & {
    width: 100%;
    height: auto;
    max-height: 70vh;
    padding: 1rem 0.5rem;
    background-color: ${props => props.theme.colors.bgPrimary};
    color: ${props => props.theme.colors.accent};
  }
`
export const StyledFilterDrawerContentWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 0 17px;
  width: 393px;
  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    width: 244px;
    padding: 0 12.5px;
  }
`

export const StyledCloseIcon = styled(CloseIcon)`
  width: 16px;
  height: 15px;
  cursor: pointer;
  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    width: 12px;
    height: 12px;
  }
`

export const StyledDrawerInputsContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 17px !important;
  margin-top: 17px;
  margin-bottom: 17px;
  width: auto;
  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    margin-top: 5px;
  }
`

export const StyledInputContainer = styled(Box)`
  & {
    color: ${props => props.theme.colors.text};
    width: 100%;
  }
`

export const StyledTopBarContainer = styled(Box)`
  & {
    padding: 0 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    
    .top-bar {
      width: 50px;
      height: 3px;
      background-color: ${props => props.theme.colors.accent};
      border-radius: 8px;
    }
  }
`

export const StyledFilterDrawerItem = styled(ListItem)`
  & {
    padding-left: 0;
  }
`
